import React from "react";

const Index = () => {
  const features = [
    {
      title: "Analytics",
      description: "Get detailed insights into your business performance.",
      image: "/Assets/images/analytics.png",
    },
    {
      title: "Product Development",
      description:
        "Develop and deploy powerful software solutions to drive efficiency and innovation.",
      image: "/Assets/images/coding.png",
    },
    {
      title: "E-Commerce",
      description: "Simplify online selling and scale your business with tailored e-commerce solutions.",
      image: "/Assets/images/e-commerce.png",
    },
    {
      title: "Support",
      description: "24/7 customer support for all your needs.",
      image: "/Assets/images/support.png",
    },
    {
      title: "Integration",
      description: "Seamlessly integrate with your existing tools.",
      image: "/Assets/images/integration.png",
    },
    {
      title: "Security",
      description: "Keep your data safe with advanced security features.",
      image: "/Assets/images/security.png",
    },
  ];

  return (
    <section id="features" className="py-10 md:py-44 px-4 bg-gray-50">
      <div className="container mx-auto text-center">
        <h3 className="text-3xl font-extrabold mb-10 text-primary">Our Features</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto cursor-pointer">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transform transition-transform duration-300 hover:-translate-y-2 text-center"
            >
              <div className="mb-4">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="mx-auto w-[150px] h-[150px]"
                />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-gray-800">
                {feature.title}
              </h4>
              <p className="text-sm text-gray-600 mb-4">
                {feature.description}
              </p>
              <button className="bg-secondary text-white font-semibold py-2 px-4 rounded-full shadow-md hover:bg-primary transition-all duration-300">
                Learn More
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Index;
